import { Disclosure } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
import { IoTriangle } from 'react-icons/io5';

import type { FaqsWithCategory as FaqsWithCategoryType } from '@/blocks/faqs-with-category';

import Faq from '../Core/Faq/Faq';

interface FaqsWithCategoryProps {
  block: FaqsWithCategoryType;
  className?: string;
}

const FaqsWithCategory = ({ block }: FaqsWithCategoryProps) => {
  const { faqsWithCategory } = block;

  if (faqsWithCategory?.length === 0) return null;

  return (
    <div className="flex flex-col space-y-8 md:space-y-16">
      {faqsWithCategory.map((item, i) => (
        <Disclosure as="div" key={`${item.category}:${i}`}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex items-center space-x-3">
                <div className="text-3xl font-black uppercase text-cream md:text-4xl">
                  {item.category}
                </div>
                <IoTriangle
                  className={clsx(
                    'h-4 w-4 text-cream transition-transform duration-300 ease-in-out',
                    open ? 'rotate-180' : 'rotate-90'
                  )}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="text-gray-500">
                {item.faqs.map(({ faq }) => (
                  <Faq
                    key={faq.question}
                    question={faq.question}
                    answer={faq.answer}
                    defaultOpen={item.defaultOpen}
                  />
                ))}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
};

export default FaqsWithCategory;
